import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { searchByName } from "../actions"
import style from "./searchbar.module.css"

function SearchBar() {
  const dispatch = useDispatch()
  const error = useSelector(state => state.error)
  const [input, setInput] = useState("")

  const handleInput = (e) => {
    setInput(e.target.value)

  }

  const handleSearch = (e) => {
    e.preventDefault()
    setInput("")
    dispatch(searchByName(input))
  }
  return (
    <div className={style.container}>
        <form onSubmit={handleSearch}>
            <input onChange={handleInput} value={input} type="text" placeholder='Search by Name' className={style.input}>
            </input>
            <button className={style.button}>Search</button>
            { error ? <div className={style.error}>No videogame with that name has been found</div> : <p></p>}
            
        </form>
    </div>
  )
}

export default SearchBar